import { render, staticRenderFns } from "./firmBasic.vue?vue&type=template&id=07c8d126&scoped=true"
import script from "./firmBasic.vue?vue&type=script&lang=js"
export * from "./firmBasic.vue?vue&type=script&lang=js"
import style0 from "./firmBasic.vue?vue&type=style&index=0&id=07c8d126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8d126",
  null
  
)

export default component.exports